import React from "react";
import TextField from '@material-ui/core/TextField';
import { Grid } from "@material-ui/core";
import CategoryIcon from "../CategoryIcon";

const SafetyNotesAdditional = (props) => {
    const {title, notes, handleChange, category} = (props)
    
    return(
        <div>
            <Grid item container className="items-start py-2" wrap="nowrap">
                <CategoryIcon category={category}/>
                <h5>{title}</h5>                    
            </Grid>
            <Grid item className='notes pt-2 pr-2'>
                <TextField
                    multiline
                    minRows={3}
                    maxRows={3}
                    fullWidth
                    value={notes || ''}
                    onChange={evt => handleChange(evt.target.value)}
                    variant="outlined"
                    inputProps={{
                        maxLength: 156
                    }}
                />
            </Grid>
        </div>
    )
}
export default SafetyNotesAdditional